// extracted by mini-css-extract-plugin
module.exports = {"GetToKnowItem":"GetToKnowItem_GetToKnowItem__3Nbwh","GetToKnowItemInfo":"GetToKnowItem_GetToKnowItemInfo__1K6o9","position":"GetToKnowItem_position__UtgTX"};